import { useQuery } from 'react-query';
import { useOkapiKy, useNamespace, } from '@folio/stripes/core';
import { MOSAIC_CONFIGURATION_API } from '../../constants';
export var useMosaicConfiguration = function () {
    var ky = useOkapiKy();
    var namespace = useNamespace({ key: 'mosaic-configuration' });
    var _a = useQuery({
        queryKey: [namespace],
        queryFn: function (_a) {
            var signal = _a.signal;
            return ky.get(MOSAIC_CONFIGURATION_API, { signal: signal }).json();
        },
    }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading, refetch = _a.refetch;
    return {
        isFetching: isFetching,
        isLoading: isLoading,
        mosaicConfiguration: data,
        refetch: refetch,
    };
};
